import { parseLocalYmd } from "@/utils/localDate";
const state = {
  selectedPlatforms: [],
  replyStatus: {},
  dateRange: {
    start: null, // 存储格式：'YYYY-MM-DD' 字符串
    end: null,
  },
  categories: null,
  CurrentRangeType: null,
  ReviewShowType: true,
};

const mutations = {
  change_ReviewShowType(state, showType) {
    state.ReviewShowType = showType;
  },
  changeCurrentRange(state, newRange) {
    state.CurrentRangeType = newRange;
  },
  // setDateRange was an old array-form mutation that stored dateRange as [start, end],
  // inconsistent with the { start, end } object shape used everywhere else.
  // It was never called by any component and would break all getters if used.
  // Disabled to prevent accidental use.
  SET_SELECTED_PLATFORMS(state, platforms) {
    // 平台名统一处理：去重 + 首字母大写
    const lowerUniquePlatforms = [
      ...new Set(platforms.map((p) => p.toLowerCase().trim())),
    ];
    const capitalizedPlatforms = lowerUniquePlatforms.map((platform) => {
      if (!platform) return "";
      return platform.charAt(0).toUpperCase() + platform.slice(1).toLowerCase();
    });
    state.selectedPlatforms = capitalizedPlatforms;
    if (process.env.NODE_ENV !== 'production') {
      console.log(`【Vuex更新】选中平台: ${capitalizedPlatforms.join(", ")}`);
    }
  },
  SET_DATE_RANGE(state, { start, end }) {
    state.dateRange = {
      start: typeof start === "string" ? start : null,
      end: typeof end === "string" ? end : null,
    };
    if (process.env.NODE_ENV !== "production") {
      console.log(`[Vuex] 日期范围更新: ${state.dateRange.start} 至 ${state.dateRange.end}`);
    }
  },
  SET_CATEGORIES(state, categories) {
    state.categories = categories;
    // console.log(`[Vuex] categories数据已更新`);
  },
};

const actions = {
  updateSelectedPlatforms({ commit }, platforms) {
    commit("SET_SELECTED_PLATFORMS", platforms);
  },
  updateDateRange({ commit, state }, dateRange) {
    if (!Array.isArray(dateRange) || dateRange.length !== 2) {
      console.error("日期范围格式错误，必须为 [start, end] 数组");
      return;
    }

    // 改进的日期格式化方法，确保日期计算正确
    const formatDate = (date) => {
      if (!date) return null;

      let d;
      if (date instanceof Date) {
        d = new Date(date); // 复制日期对象避免修改原对象
      } else if (typeof date === "number") {
        d = new Date(date);
      } else if (typeof date === "string") {
        // WTK-815：'YYYY-MM-DD' 按本地零点解析（new Date 会当成 UTC 零点，美洲时区会早一天）
        d = parseLocalYmd(date);
      } else {
        console.warn("无效日期格式，已忽略:", date);
        return null;
      }

      // 关键修复：添加时区偏移量，避免本地时间转UTC时日期减少一天
      const offset = d.getTimezoneOffset();
      d = new Date(d.getTime() - offset * 60 * 1000);

      const year = d.getUTCFullYear();
      const month = String(d.getUTCMonth() + 1).padStart(2, "0");
      const day = String(d.getUTCDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    };

    const start = formatDate(dateRange[0]);
    const end = formatDate(dateRange[1]);

    if (start && end) {
      commit("SET_DATE_RANGE", { start, end });
    } else {
      console.warn("日期范围不完整，未更新状态");
    }
  },
  updateCategories({ commit }, categories) {
    if (categories && typeof categories === "object") {
      commit("SET_CATEGORIES", categories);
    } else {
      console.warn("[Vuex] 无效的categories数据格式");
    }
  },
};

const getters = {
  selectedPlatforms: (state) => state.selectedPlatforms,
  selectedPlatformsCount: (state) => state.selectedPlatforms.length,
  categories: (state) => state.categories || {},
  // 获取日期范围的getter，返回格式化后的对象
  dateRange: (state) => state.dateRange,
  // 判断日期范围是否有效
  isDateRangeValid: (state) => {
    return (
      !!state.dateRange.start &&
      !!state.dateRange.end &&
      new Date(state.dateRange.end) >= new Date(state.dateRange.start)
    );
  },
  // 新增：获取日期范围数组格式 [start, end]
  dateRangeArray: (state) => {
    if (state.dateRange.start && state.dateRange.end) {
      return [new Date(state.dateRange.start), new Date(state.dateRange.end)];
    }
    return [];
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
